<div class="login-wrapper">
  <div class="container">
    <div class="row align-items-start">

      <!-- LEFT -->
      <div class="col-lg-6 login-left">
        <h1>Welcome to Builder</h1>
        <p class="subtitle">We make Real Estate Easy for everyone</p>
        <img src="assets/login_image.svg" class="login-image">

        <h3>Why you should choose us :</h3>

        <ul>
          <li>Connect with Global Network of Buyers & Investors.</li>
          <li>Real FinTech Platform to close 10X Deals.</li>
          <li>Credit Bureau Support for Financial Assessment.</li>
          <li>Post a property for FREE.</li>
          <li>List Properties till Sale.</li>
          <li>Enjoy two months Cash Back on EMIs.</li>
          <li>10+ Business Opportunities from Franchise Network.</li>
          <li>Get home loans easily from the banks you use.</li>
          <li>Sell your properties 10X faster.</li>
          <li>Connect with Verified Buyers & Tenants.</li>
          <li>Get Unlimited Enquiries on Your Property.</li>
        </ul>
      </div>

      <!-- RIGHT -->
      <div class="col-lg-6 d-flex justify-content-center">

        <!-- FORGOT PASSWORD MODAL -->
    <!-- FORGOT PASSWORD -->
<div class="logincontainer" *ngIf="showForgotPassword">

  <div class="forgot-password-header">
    <span class="back-btn" (click)="backToLogin()">← Back to Login</span>
    <h2>Forgot Password</h2>
  </div>

  <!-- MOBILE NUMBER -->
  <label>Mobile Number</label>
  <div class="input-box" style="display:flex;gap:10px;align-items:center">

    <select class="country-select" [(ngModel)]="forgotCountryCode">
      <option *ngFor="let country of countryCodes" [value]="country.code">
        {{country.flag}} {{country.code}}
      </option>
    </select>

    <input
      placeholder="Enter mobile number"
      [(ngModel)]="forgotMobile"
      (input)="onForgotMobileChange()"
      maxlength="10">

  </div>

  <div class="error" *ngIf="forgotMobileError">
    Enter valid 10 digit mobile number
  </div>

  <button
  class="login-btn"
  (click)="sendOtpForgot()"
  [disabled]="forgotMobile.length !== 10">
  SEND OTP
</button>


  <!-- OTP -->
  <label>Enter OTP</label>

  <div class="input-box">
    <input
      placeholder="Enter OTP"
      [(ngModel)]="forgotOtp"
      (blur)="forgotOtpTouched = true">
  </div>

  <div class="error" *ngIf="forgotOtpTouched && !forgotOtp">
    OTP required
  </div>

  <div class="error" *ngIf="forgotOtp && forgotOtp.length !== 6">
    Enter valid 6 digit OTP
  </div>


  <!-- NEW PASSWORD -->
  <label>New Password</label>

  <div class="input-box">

    <input
      (input)="checkPasswordForgotNew($event)"
      (blur)="forgotNewPasswordTouched = true"
      [type]="showForgotNewPassword ? 'text' : 'password'"
      placeholder="Enter new password"
      [(ngModel)]="forgotNewPassword">

    <span class="eye" (click)="toggleForgotNewPassword()">👁</span>

  </div>

  <div
    class="password-required"
    *ngIf="forgotNewPasswordTouched && !forgotNewPassword">
    Password required
  </div>

  <div class="password-rules" *ngIf="forgotNewPassword">

    <p [class.valid]="forgotPasswordRules.length">• Minimum 6 characters</p>

  </div>


  <!-- CONFIRM PASSWORD -->
  <label>Confirm Password</label>

  <div class="input-box">

    <input
      (input)="onConfirmPasswordChange()"
      (blur)="confirmPasswordTouched = true"
      [type]="showForgotConfirmPassword ? 'text' : 'password'"
      placeholder="Confirm new password"
      [(ngModel)]="forgotConfirmPassword">

    <span class="eye" (click)="toggleForgotConfirmPassword()">👁</span>

  </div>

  <div
    class="password-required"
    *ngIf="confirmPasswordTouched && !forgotConfirmPassword">
    Confirm password required
  </div>

  <div
    class="confirm-password-error"
    *ngIf="forgotConfirmPassword && passwordsDontMatch">
    Passwords do not match
  </div>


  <!-- SUCCESS MESSAGE -->
  <div *ngIf="passwordResetSuccess"
       style="color:green;font-weight:600;margin-top:10px;">
    ✔ Password changed successfully
  </div>


  <!-- SUBMIT -->
  <button
    class="login-btn"
    (click)="resetPassword()"
    [disabled]="!isResetPasswordValid()">
    Submit
  </button>

</div>

        <!-- MAIN LOGIN/SIGNUP -->
        <div class="logincontainer" *ngIf="!showForgotPassword">

          <div class="tabs">
            <button [class.active]="activeTab==='login'" (click)="switchTab('login')">Login</button>
            <button [class.active]="activeTab==='signup'" (click)="switchTab('signup')">Sign Up</button>
          </div>

          <!-- LOGIN -->
          <div *ngIf="activeTab==='login'">
            <label>Mobile Number</label>
            <div class="input-box" style="display:flex;gap:10px;align-items:center">
              <select class="country-select"
              [(ngModel)]="selectedCountryCode"
              (change)="onCountryChange(selectedCountryCode)">
                <option *ngFor="let country of countryCodes" [value]="country.code">
                  {{country.flag}} {{country.code}}
                </option>
              </select>
              <input
              [placeholder]="' Enter mobile number'"
              [formControl]="l.mobile">
            </div>
            <div class="error" *ngIf="l.mobile.touched && l.mobile.invalid">
              Enter valid 10 digit mobile number
            </div>

            <!-- FIXED LOGIN PASSWORD -->
            <label>Password</label>
            <div class="input-box">
              <input
                (input)="checkPassword('login',$event)"
                (blur)="loginPasswordTouched = true"
                [type]="showPassword?'text':'password'"
                placeholder="Enter password"
                [formControl]="l.password">
              <span class="eye" (click)="togglePassword()">👁</span>
            </div>
            <div class="password-required"
     *ngIf="l.password.touched && !l.password.value">
  Password required
</div>

<div class="password-rules"
     *ngIf="l.password.value">
              <p [class.valid]="passwordRulesLogin.length">• Minimum 6 characters</p>
            </div>

            <button class="login-btn" (click)="loginstaff()">
              LOGIN
            </button>

            <!-- FORGOT PASSWORD LINK -->
            <div class="forgot-password-link">
              <a href="#" (click)="showForgotPasswordFlow(); $event.preventDefault()">Forgot Password?</a>
            </div>
          </div>

          <!-- SIGNUP -->
          <div *ngIf="activeTab==='signup'">
            <label>Name</label>
            <div class="input-box">
              <input placeholder="Enter name" [formControl]="s.name">
            </div>
            <div class="error" *ngIf="s.name.touched && s.name.invalid">
              Name required
            </div>

            <label>Mobile Number</label>
            <div class="input-box" style="display:flex;gap:10px;align-items:center">
              <select class="country-select"
              [(ngModel)]="selectedCountryCode"
              (change)="onCountryChange(selectedCountryCode)">
                <option *ngFor="let country of countryCodes" [value]="country.code">
                  {{country.flag}} {{country.code}}
                </option>
              </select>
            <input
type="tel"
maxlength="10"
[placeholder]="' Enter mobile number'"
[formControl]="s.mobile"
(input)="otpVerified=false">
            </div>
            <div class="error" *ngIf="s.mobile.touched && s.mobile.invalid">
              Enter valid 10 digit mobile
            </div>

            <button class="otp-btn"
            [disabled]="s.mobile.invalid"
            (click)="sendOtp()">
              SEND OTP
            </button>

            <div *ngIf="otpSent">
              <label>Enter OTP</label>
              <div class="input-box">
                <input
placeholder="Enter OTP"
maxlength="6"
[formControl]="s.otp"
(input)="verifyOtpSignup()">
<div class="error"
*ngIf="s.otp.value && s.otp.value.length !== 6">
Enter valid 6 digit OTP
</div>
              </div>
            </div>

            <label>Email</label>
            <div class="input-box">
              <input placeholder="Enter email" [formControl]="s.email">
            </div>
            <div class="error" *ngIf="s.email.touched && s.email.invalid">
              Enter valid email
            </div>

            <!-- FIXED SIGNUP PASSWORD -->
            <label>Password</label>
            <div class="input-box">
              <input
                (input)="checkPassword('signup',$event)"
                (blur)="signupPasswordTouched = true"
                [type]="showPassword?'text':'password'"
                placeholder="Enter password"
                [formControl]="s.password">
              <span class="eye" (click)="togglePassword()">👁</span>
            </div>
            <div class="password-required" *ngIf="s.password.touched && !s.password.value">
              Password required
            </div>
           <div class="password-rules" *ngIf="s.password.value">
              <p [class.valid]="passwordRulesSignup.length">• Minimum 6 characters</p>
            </div>
<label>I am </label>
<div class="input-box" >   
  <select class="role-dropdown" formControlName="role"    >
    <option value="" disabled selected>Select Role</option>
    <option value="">None</option>
    <option value="Agent">Agent</option>
    <option value="Channel Partner">Channel Partner</option>
    <option value="Builder">Builder</option>
  </select>
</div>

<div class="error" *ngIf="s.role.touched && s.role.invalid">
  Please select a role
</div>

            <button class="signup-btn" (click)="signup()">
              SIGN UP
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="toast-msg" *ngIf="showToastMessage">
  ✔ {{toastMessage}}
</div>
</div>